require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./journal-grange-residence-featured-on-est-living.json") })
        }
      }, "path---journal-grange-residence-featured-on-est-living");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---journal-grange-residence-featured-on-est-living!./.cache/json/journal-grange-residence-featured-on-est-living.json
// module id = 496
// module chunks = 231608221292675